<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-row>
        <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">คำสั่งซื้อของฉัน</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
          <v-card>
            <v-card-title>ประวัติการสั่งซื้อของฉัน</v-card-title>

            <v-card-text v-for="(order, index) in data_list" :key="index">
              <v-expansion-panels elevation="4" :disabled="disabled">
                <v-expansion-panel class="rounded-xl" style="background-color: #FAF7F5">
                  <v-expansion-panel-header @click="panel = (panel == index) ? -1 : index">
                    <v-row>
                      <v-col xs="12" sm="12" md="3" lg="3" xl="3" cols="12" class="d-flex" style="align-items:center;">
                        <div class="mr-2" style="font-weight: 500;font-size: 16px;color: #909090;">เลขที่ใบสั่งซื้อ :
                        </div>
                        <div style="font-weight: 500;font-size: 16px;color: #616A6B;">{{ order.order_code }}</div>
                      </v-col>
                      <v-col xs="12" sm="12" md="3" lg="3" xl="3" cols="12" class="d-flex" style="align-items:center;">
                        <div class="mr-2" style="font-weight: 500;font-size: 16px;color: #909090;">วันที่สั่งซื้อ :
                        </div>
                        <div style="font-weight: 500;font-size: 16px;color: #616A6B;">{{ order.created_at }}</div>
                      </v-col>
                      <v-col xs="12" sm="12" md="3" lg="3" xl="3" cols="12" class="d-flex" style="align-items:center;">
                        <div class="mr-2" style="font-weight: 500;font-size: 16px;color: #909090;">ยอดการสั่งซื้อ :
                        </div>
                        <div style="font-weight: 500;font-size: 16px;color: #616A6B;">{{ formatPrice(parseFloat(order.total) + parseFloat(order.delivery_price)) }} บาท</div>
                      </v-col>
                        <v-col xs="12" sm="12" md="3" lg="3" xl="3" cols="12" class="d-flex" style="align-items:center;" v-if="order.customer_type === 3">   
                        <div class="tag_arin_magnify pa-3 mr-7" v-if="order.status == 3">กรุณาติดต่อเจ้าหน้าที่</div>
                        <div class="tag_arin_magnify pa-3 mr-7" v-if="order.status == 0 || order.status == 1">กำลังตรวจสอบ</div>      
                        <div class="tag_arin_magnify_success pa-3 mr-7" v-if="order.status == 2">จัดส่งแล้ว</div>
                        <div class="tag_arin_magnify_success pa-3 mr-7" v-if="order.status == 4">เสนอดีลใหม่</div>
                        </v-col>
                        <v-col xs="12" sm="12" md="3" lg="3" xl="3" cols="12" class="d-flex" style="align-items:center;" v-else>
                          <div class="tag_arin_magnify pa-3 mr-7" v-if="order.status == 0">รอดำเนินการ</div>   
                          <div  v-else-if="order.status == 1">
                            <div class="tag_arin_magnify pa-3 mr-7" v-if="order.slip_status == 2">กรุณาติดต่อเจ้าหน้าที่</div>
                            <div v-else>
                              <div class="tag_arin_magnify pa-3 mr-7" v-if="order.payment_status == 1">กำลังตรวจสอบ</div>
                              <div class="tag_arin_magnify pa-3 mr-7" v-else>รอการชำระเงิน</div>        
                            </div>
                          </div>
                        <div class="tag_arin_magnify_success pa-3 mr-7" v-else-if="order.status == 2">จัดส่งแล้ว</div>
                        <div class="tag_arin_magnify_cancel pa-3 mr-7" v-else-if="order.status == 3">ยกเลิก</div>
                        <div v-if="order.status == 4">
                          <div class="tag_arin_magnify_cancel pa-3 mr-7" v-if="order.slip_status == 2">
                            กรุณาติดต่อเจ้าหน้าที่</div>
                            <div v-else>
                              <div class="tag_arin_magnify pa-3 mr-7" v-if="order.payment_status == 1">กำลังตรวจสอบ</div>
                              <div class="tag_arin_magnify_success pa-3 mr-7" v-else>เสนอดีลใหม่</div>
                            </div>
                        </div>
                        </v-col>
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-text v-if="panel == index">
                    <v-row>
                      <v-col cols="12">
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <td class="text-center">
                                  รูปภาพ
                                </td>
                                <td class="text-left">
                                  ชื่อสินค้า
                                </td>
                                <td class="text-center">
                                  ราคาต่อหน่วย
                                </td>
                                <td class="text-center">
                                  จำนวน
                                </td>
                                <td class="text-center">
                                  ราคารวม
                                </td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="item in order.list" :key="item.id">
                                <td class="pa-3 hidden_line">
                                  <div><v-img height="80" max-width="80" :lazy-src="item.product_pic"
                                      :src="item.product_pic" class="preview"></v-img></div>
                                </td>
                                <td class="hidden_line">
                                  <div :style="item.product_cancel == 1 ? 'text-decoration:line-through; color: red;' : ''">{{ item.product_name_fixed }}</div>
                                  <div class="grey--text"><small>{{ item.name_sci }}</small></div>
                                </td>
                                <td class="hidden_line">
                                  <div class="text-center" :style="item.product_cancel == 1 ? 'text-decoration:line-through; color: red;' : ''">฿ {{ formatPrice(parseFloat(item.cost)) }}</div>
                                </td>
                                <td class="hidden_line">
                                  <div class="text-center">
                                    <div class="pr-2" :style="item.product_cancel == 1 ? 'text-decoration:line-through; color: red;' : ''">{{ item.quantity + ' ' + item.unit_name }}
                                    </div>
                                  </div>
                                </td>
                                <td class="hidden_line">
                                  <div class="text-center" :style="item.product_cancel == 1 ? 'text-decoration:line-through; color: red;' : ''">฿ {{ formatPrice(parseFloat(item.total)) }}</div>
                                </td>
                              </tr>
                              <tr>
                                <td class="bt-color"></td>
                                <td class="bt-color"></td>
                                <td class="text-center mr-3 bt-color "><b>ค่าจัดส่ง</b></td>
                                <td class="bt-color"></td>
                                <td class="text-center bt-color"><b>฿ {{ formatPrice(parseFloat(order.delivery_price)) }}</b></td>
                              </tr>
                              <tr>
                                <td class="text-center hidden_line"></td>
                                <td class="text-center hidden_line"></td>
                                <td class="text-center hidden_line mr-3"><b>รวม</b></td>
                                <td class="text-center hidden_line"></td>
                                <td class="text-center hidden_line"><b>฿ {{ formatPrice(parseFloat(order.total) + parseFloat(order.delivery_price)) }}</b></td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>
                      <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12"
                        v-if=" order.customer_type != 3 && order.status != 0 && order.status != 2 && order.status != 3 && order.slip_status != 2 && order.payment_status == 0">
                        <div class="title_page ma-3" style="justify-content:center;">
                          <v-btn type="button" class="input-radius" outlined color="success" elevation="3"
                            @click="linkPage(order.order_code)" large>
                            ชำระเงิน
                          </v-btn>
                        </div>
                      </v-col>
                      <!-- <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12"
                        v-if="order.status == 0 || order.status == 1">
                        <div class="title_page ma-3" style="justify-content:center;">
                          <v-btn type="button" class="input-radius" outlined color="error" elevation="3"
                            @click="cancel_order(order.id)" large>
                            <v-img height="25" max-width="25" :lazy-src="img_cancel_order" :src="img_cancel_order"
                              class=" mr-2"></v-img>
                            ยกเลิกคำสั่งซื้อ
                          </v-btn>
                        </div>
                      </v-col> -->
                    </v-row>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card-text>
           <div @click="getOrder()">
             <v-pagination class="mt-4 mb-4" v-model="page" :length="count_page"></v-pagination>
           </div>
          </v-card>
          <v-dialog v-model="dialog_cancel_order" persistent max-width="375">
            <v-card>
              <div class="d-flex justify-space-between">
                <v-card-title>
                  <b>ยกเลิกคำสั่งซื้อ</b>
                </v-card-title>
                <v-btn icon class="ma-4" @click="dialog_cancel_order = false">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <v-row>
                  <v-col cols="12" class="text-center">
                    <v-img height="80" max-width="80" :lazy-src="img_cancel_order" :src="img_cancel_order"
                      class="preview mt-3 mb-2"></v-img>
                    <h3>คุณต้องการยกเลิกคำสั่งซื้อหรือไม่ ?</h3>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn type="button" class="btn_add_data" elevation="4" large
                  @click="confirm_cancel_order(confirm_delete_id)">ยืนยัน</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
// import img_holder from "@/assets/arin_assets/image_sun_color.png";
import cancel_order from "@/assets/arin_assets/cancel_order.png";
import { HTTP_ARIN } from "@/axios_arin";
import Swal from "sweetalert2";
import {formatPrice} from "@/js/handler";
export default {
  name: "Pos_my_order_list",
  data() {
    return {
      img_cancel_order: cancel_order,
      dialog_cancel_order: false,
      loading_page: false,
      panel: -1,
      page: 1,
      count_page: 1,
      disabled: false,
      footer_Props: {
        'items-per-page-text': 'รายการต่อหน้า'
      },
      sub_menu: [
        {
          text: 'ระบบ POS',
          disabled: false,
        },
        {
          text: 'ออกใบสั่งซื้อ',
          disabled: false,
        },
        {
          text: 'คำสั่งซื้อของฉัน',
          disabled: false,
          href: '#',
        },
      ],
      headers: [
        {
          text: 'รูปภาพ',
          value: '',
          fixed: true,
          width: '120px',
          sortable: false,
          align: 'center',
        },
        {
          text: 'ชื่อสินค้า',
          value: '',
          fixed: true,
          width: '300px',
          align: 'left',
        },
        {
          text: 'ราคาต่อหน่วย',
          value: '',
          fixed: true,
          width: '160px',
          align: 'center',
        },
        {
          text: 'จำนวน',
          value: '',
          fixed: true,
          width: '170px',
          align: 'center',
        },
        {
          text: 'ราคารวม',
          value: '',
          fixed: true,
          width: '170px',
          align: 'center',
        },
      ],
      data_list: [],
      detail: [],
      confirm_delete_id: null,
    }
  },
  methods: {
    formatPrice: function(value) {
      return formatPrice(value)
    },
    linkPage(order){
      window.open(`${process.env.VUE_APP_BASE_URL.replace('/api', '')}/wholesaleshops/moneytransfer/${order}?url=1`, '_blank')
    },
    getOrder() {
      this.data_list = [];
      this.detail = [];
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/pos/order?page='+this.page, config).then((res) => {
        if (res.data.successful === true) {
          // HTTP_ARIN.get('/pos/order', config).then((response) => {
          //   if (response.data.successful === true) {
          //     console.log(response.data)
          //     this.detail = response.data.detail
          //   }
          // })
          this.data_list = res.data.order
          this.detail = res.data.order.list
          this.data_list = this.data_list.map(item => {
            return {
              ...item,
              created_at: item.created_at.split(' ')[0],
            }
          })
           this.count_page = res.data.count_page
           this.page = parseInt(res.data.current_page)
           this.panel = -1
        }
      })
    },
    cancel_order(id) {
      this.dialog_cancel_order = true;
      this.confirm_delete_id = id;
    },
    confirm_cancel_order() {
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/pos/order/cancle/' + this.confirm_delete_id, config)
        .then((res) => {
          if (res.data.successful === true) {
            let timerInterval
            Swal.fire({
              title: 'เสร็จสิ้น',
              text: 'ยกเลิกคำสั่งซื้อเรียบร้อย',
              icon: 'success',
              timer: 2000,
              timerProgressBar: true,
              didOpen: () => {
                Swal.showLoading()
                timerInterval = setInterval(() => { }, 100)
              },
              willClose: () => {
                clearInterval(timerInterval)
                setTimeout(function () {
                  window.location.reload();
                });
              }
            })
          }
          else {
            Swal.fire({
              title: 'แจ้งเตือน',
              text: 'ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง!',
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            })
          }
        })
    }
  },
  mounted() {
    this.getOrder()
  },
}
</script>

<style scoped>
.header_title {
  font-weight: 600;
  font-size: 20px;
  color: #616A6B;
}

.bt-color {
  border-top: thin solid rgba(0, 0, 0, 0.12) !important;
}

.font_mobile {
  font-size: 14px !important;
}

.grid_three {
  display: flex;
  justify-content: space-between;
}

.tag_arin_magnify {
  border: 1px solid #FEA06C;
  color: #FEA06C;
  font-weight: 500;
  font-size: 16px;
  border-radius: 10px;
  background-color: #FFFFFF;
}

.tag_arin_magnify_success {
  border: 1px solid #4caf50;
  color: #4caf50;
  font-weight: 500;
  font-size: 16px;
  border-radius: 10px;
  background-color: #FFFFFF;
}

.tag_arin_magnify_cancel {
  border: 1px solid #ff5252;
  color: #ff5252;
  font-weight: 500;
  font-size: 16px;
  border-radius: 10px;
  background-color: #FFFFFF;
}

.preview {
  border-radius: 10px;
  margin: auto;
}

.btn_add_data {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
  border-radius: 10px;
  width: 50%;
}

.btn_add_data_submit_order {
  font-size: 16px;
  color: #FFF;
  /* background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important; */
  border-radius: 10px;
  width: 15%;
}

@media only screen and (min-width: 0px)AND (max-width: 361px) {
  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 100%;
  }

  .btn_add_data_submit_order {
    font-size: 16px;
    color: #FFF;
    border-radius: 10px;
    width: 100%;
  }
}

@media only screen and (max-width: 600px) {
  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 100%;
  }

  .btn_add_data_submit_order {
    font-size: 16px;
    color: #FFF;
    border-radius: 10px;
    width: 50%;
  }
}

@media only screen and (min-width: 601px) AND (max-width: 960px) {
  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 50%;
  }

  .btn_add_data_submit_order {
    font-size: 16px;
    color: #FFF;
    border-radius: 10px;
    width: 50%;
  }
}

@media only screen and (min-width: 961px) AND (max-width: 1264px) {
  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 50%;
  }

  .btn_add_data_submit_order {
    font-size: 16px;
    color: #FFF;
    border-radius: 10px;
    width: 50%;
  }
}

@media only screen and (min-width: 1265px) AND (max-width: 1904px) {
  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 25%;
  }

  .btn_add_data_submit_order {
    font-size: 16px;
    color: #FFF;
    border-radius: 10px;
    width: 25%;
  }
}

/* @media only screen and (min-width: 0px)AND (max-width: 361px) {}

@media only screen and (max-width: 600px) {}

@media only screen and (min-width: 601px) AND (max-width: 960px) {}

@media only screen and (min-width: 961px) AND (max-width: 1264px) {}

@media only screen and (min-width: 1265px) AND (max-width: 1904px) {} */
</style>
